import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { firstValueFrom } from 'rxjs'
import { environment } from '@env'
import { GetLinktreesRequest, GetLinktreesResponse, Linktree, SaveLinktreeRequest, SaveLinktreeResponse } from '@models'

@Injectable({
  providedIn: 'root',
})
export class LinktreeService {
  private readonly baseUrl = `${environment.api.baseUrl}/content/v1/linktrees`

  constructor(private http: HttpClient) {}

  async getAll(params?: GetLinktreesRequest): Promise<GetLinktreesResponse> {
    let httpParams = new HttpParams()

    if (params) {
      if (params.page !== undefined) httpParams = httpParams.set('page', params.page.toString())

      if (params.pageSize !== undefined) httpParams = httpParams.set('pageSize', params.pageSize.toString())

      if (params.orderBy) httpParams = httpParams.set('orderBy', params.orderBy)

      if (params.order) httpParams = httpParams.set('order', params.order)

      if (params.text) httpParams = httpParams.set('text', params.text)

      if (params.url) httpParams = httpParams.set('url', params.url)

      if (params.status !== undefined && params.status !== null)
        httpParams = httpParams.set('status', String(params.status))
    }

    const response = await firstValueFrom(this.http.get<GetLinktreesResponse>(this.baseUrl, { params: httpParams }))
    return response
  }

  async getById(id: string): Promise<Linktree> {
    const response = await firstValueFrom(this.http.get<Linktree>(`${this.baseUrl}/${id}`))
    return response
  }

  async create(payload: SaveLinktreeRequest): Promise<SaveLinktreeResponse> {
    const response = await firstValueFrom(this.http.post<SaveLinktreeResponse>(this.baseUrl, payload))
    return response
  }

  async update(id: string, payload: SaveLinktreeRequest): Promise<SaveLinktreeResponse> {
    const response = await firstValueFrom(this.http.put<SaveLinktreeResponse>(`${this.baseUrl}/${id}`, payload))
    return response
  }

  async delete(id: string): Promise<void> {
    const response = await firstValueFrom(this.http.delete<void>(`${this.baseUrl}/${id}`))
    return response
  }
}
